var scriptTag = document.getElementById('script');
var script = scriptTag.hasAttribute("data-main") ? scriptTag.getAttribute("data-main") : scriptTag.src;
var staticDomain = script.substr(0, script.lastIndexOf("js/")+2);
var revision = script.substring(script.indexOf('?') + 1);
var mod = scriptTag.getAttribute('data-module');

requirejs.config({
	paths: {
		'bower' : '../lib',
		'jqueryui' : '../lib/jquery.ui/ui',
		'jquery' : '../lib/jquery/dist/jquery',
	},
	map: {
		'*': {
			'jquery-ui/widget': 'jqueryui/widget',
			'lib/jquery-ui-timepicker-addon': 'bower/jqueryui-timepicker-addon/dist/jquery-ui-timepicker-addon',
			'lib/jquery.fileupload': 'bower/jquery-file-upload/js/jquery.fileupload',
			'lib/jquery.iframe-transport': 'bower/jquery-file-upload/js/jquery.iframe-transport',
			'lib/jquery.timeago': 'bower/jquery-timeago/jquery.timeago',
			'lib/jquery.lazyload': 'bower/jquery.lazyload/jquery.lazyload',
			'lib/mustache': 'bower/mustache.js/mustache',
			'lib/tinycon': 'bower/tinycon/tinycon',
			'lib/fullcalendar': 'bower/fullcalendar/dist/fullcalendar',
			'lib/fullcalendar.nl': 'bower/fullcalendar/dist/lang/nl',
			'lib/moment.nl': 'bower/moment/locale/nl',
			'async': "bower/requirejs-plugins/src/async",
			'propertyParser': "bower/requirejs-plugins/src/propertyParser",
			'goog': "bower/requirejs-plugins/src/goog",
			'recaptcha' : 'https://www.google.com/recaptcha/api.js',
			'moment' : 'bower/moment/moment',
		}
	},
	shim: {
		"lib/redactor": ['jquery'],
		"lib/fullcalendar": ['jquery'],
		"lib/jquery.lazyload": ['jquery'],
		"lib/fullcalendar.nl": ['lib/fullcalendar']
	}
});

requirejs.config({
	baseUrl: staticDomain,
	urlArgs: revision
});

var configure = {
	types : {
		'photos' : {
			'module' : 'photos',
			'controller' : 'photo'
		},
		'news' : {
			'module' : 'news',
			'controller' : 'news'
		},
		'forum' : {
			'module' : '',
			'controller' : 'reaction'
		},
		'activities' : {
			'module' : 'activities',
			'controller' : 'activity'
		},
		'album' : {
			'module' : 'photos'
		},
		'cms' : {
			'module' : 'cms',
			'controller' : 'menu'
		}
	}
};

requirejs(['jquery', 'meta/likes', 'utils/overlay', 'utils/loader', 'utils/scroller', 'utils/gallery', 'utils/live', 'utils/analytics', 'utils/common', 'form/selector', 'lib/jquery.timeago', 'lib/jquery.timeago.nl', 'utils/search', 'utils/forms', 'utils/messages', 'utils/socket.io'], function ($, Likes, Overlay, Loader, Scroller, Gallery, Live) {

	$.ajaxPrefilter(function( options, originalOptions, jqXHR ) {
        if (!(originalOptions.data instanceof FormData))
        {
            if (typeof originalOptions.data == 'undefined')
            {
                originalOptions.data = {};
            }
            options.data = $.param($.extend(originalOptions.data, { token: $('meta[name=csrf]').attr("content") }));
        }
        else if (typeof options.data != 'undefined') // Special treatment for FormData (used in File Upload)
        {
            options.data = originalOptions.data;
            if (options.data != null)
                options.data.append('token', $('meta[name=csrf]').attr("content"));
        }
		options.success = function(data, textStatus, jqXHR) {
            if (typeof originalOptions.success == 'undefined')
                return;

			if (typeof data.data != 'undefined' && data.data)
				originalOptions.success(data.data, textStatus, jqXHR);
			else
				originalOptions.success(data, textStatus, jqXHR);
		};

		options.error = function (data, textStatus, jqXHR, errorThrown) {
			if(data.code == 403)  {
				$.message('U hebt hiervoor geen rechten');
			} else if(data.code == 404) {
				$.message('Aanvraag niet gevonden');
			} else if(data.code == 500) {
				$.message('Interne server fout, meld bug!');
			} else {
				console.log(data, textStatus, errorThrown);
			}
		}
	});
	
    $(function () {
		$.timeago.settings.allowFuture = true;
        $('time.relative').timeago();

        $('.html_like').like();

        $('body').on('click', 'a.popup', function (e) {
            e.stopPropagation();

            //Prevent double overlays
            if ($(this).hasClass('disabled')) {
                return false;
            }
            $(this).addClass('disabled');

            var current = $(this);

            var overlay = new Overlay({
                headerCount: false,
                keepAfterHide: false,
                navigation: true,

                onData: function (data, overlay) {
                    if (data.css) {
                        if ($('link[href^="' + data.css + '"]').length === 0) {
                            $('head').append($('<link>').attr('rel', 'stylesheet').attr('type', 'text/css').attr('href', data.css));
                        }
                    }

                    if (data.js) {
                        require([data.js], function (callbacks) {
                            overlay.options.onLoad = callbacks.onLoad;
                            overlay.content(data.html);
                        });
                    } else
                        overlay.content(data.html);
                },

                callback: function () {
                    current.trigger('popupCallback');
                }
            });
            overlay.show();

            var loader = new Loader();
            overlay.getElement().append(loader.get());

            new $.get($(this).attr("href"), function (data) {
                loader.remove();
                overlay.options.onData(data, overlay);
                $('.popup').removeClass('disabled');
            });

            return false;
        });

        $('.confirmPost').click(function (e) {
            e.stopPropagation();

            var text = 'Weet u zeker dat u dit item wilt ';
            if ($(this).hasClass('delete'))
                text += 'verwijderen?';
            else if ($(this).hasClass('hide'))
                text += 'verbergen?';
            else if ($(this).hasClass('private'))
                text += 'sluiten?';
            else
                text = 'Weet u het zeker?'

            var confirm = $(this);

            $.confirmBox(function () {
                var f = $('<form method="post" action="' + confirm.attr('href') + '"></form>');
                f.html('<input type="hidden" name="token" value="' + $('meta[name=csrf]').attr("content") + '" />');
                f.appendTo($('body')); // required for submission to work in Firefox
                f.submit();
            }, text);
            return false;
        });

        $('a[href^="znvygb:"]').mouseover(function (e) {
            $(this).attr('href', $(this).attr('href').rot13().replace('?', '@'));
            $(this).off('mouseover');
        });

        $('.obfuscate').each(function () {
            $(this).text($(this).text().rot13().replace('?', '@')).removeClass('obfuscate');
        });

        /** ADS */
        var ads = $('.ads');
        new Scroller({
            container: ads,
            height: ads.data('height') != undefined ? ads.data('height') : 200,
			width: ads.data('width') != undefined ? ads.data('width') : 300
        });

        /** SLIDER ON HOMEPAGE */
        new Gallery();
    });
	
	require([mod], function (module) {
		//module is now loaded.
	});

	//Sneller ready event als onDOMContentLoaded event te voeg is geweest
	if (document.readyState === "interactive")
		$.ready();
});


define("main", function(){});

